/**
 * Breadcrumb labels for the authenticated header.
 *
 * Only labels the sidebar does not already name live here — the header merges
 * `main-navigation/locales` first, so anything that appears in both places (Create Leads, Motor
 * Policy, Credits, …) is translated once, in the nav locale, and cannot drift between the two.
 */

export const en = {
  // --- Root / misc ---
  home: 'Home',
  buyInsurance: 'Buy Insurance',
  affiliateDashboard: 'Affiliate Dashboard',
  customerSupport: 'Customer Support',
  opsDashboard: 'OPS Dashboard',
  teams: 'Teams',
  downline: 'Downline',
  shortenedUrl: 'Shortened URL',

  // --- Quote → plan → sale journey ---
  vmi: 'VMI',
  selectPlans: 'Select Plans',
  requestCustomQuote: 'Request Custom Quote',
  reportSale: 'Report Sale',
  sendToCustomer: 'Send to Customer',
  quotations: 'Quotations',
  bikeInsurance: 'Bike Insurance',
  bikeCustomQuote: 'Bike Custom Quote',
  nonMotorDeclaration: 'Non-Motor Declaration',
  nonMotorPostquote: 'Non-Motor Post Quote',
  nonMotorPayment: 'Non-Motor Payment',

  // --- Leads / policies ---
  newLeads: 'New Leads',
  changeOfAgent: 'Change of Agent',
  renewals: 'Renewals',
  fullPayment: 'Full Payment',
  endorsements: 'Endorsements',
  commissionRates: 'Commission Rates',

  // --- Sale-update flows (single label each — the stages are not separate crumbs) ---
  switchPackage: 'Switch Package',
  updatePremium: 'Update Premium',
  recordEndorsement: 'Record Endorsement',
  cancellationEndorsement: 'Cancellation Endorsement',
  internalInformationUpdate: 'Internal Information Update',

  // --- Accounting ---
  pendingPayments: 'Pending Payments',
  uploadTransferCsv: 'Upload Transfer CSV',
  combinedPayments: 'Combined Payments',
  combinedEndorsement: 'Combined Endorsement',
  uploadCsvEndorsement: 'Upload CSV Endorsement',
  soaV1: 'SOA V1',
  soaResults: 'SOA Results',
  manualEkycTransfer: 'Manual EKYC Transfer',
  creditInvoices: 'Credit Invoices',
  travel: 'Travel',
  allProducts: 'All Products',

  // --- Admin ---
  inventory: 'Inventory',
} as const;
